<template>
  <div class="bg-initial">
    <v-container fluid fill-height class="overlay">
      <v-row align="center"
             justify="center">
        <v-col cols="12">
          <v-card
            class="mx-auto"
            max-width="500"
          >
            <v-card-title class="font-weight-bold">
              Entidades
            </v-card-title>
            <v-card-text class="text--primary">
              <div class="body-2">
                Selecione uma entidade para prosseguir.
              </div>
              <v-skeleton-loader
                :loading="loading"
                max-width="400"
                class="mt-3"
                type="list-item, list-item"
              >
                <v-list>
                  <v-list-item v-for="entidade in entidades"
                               :key="entidade.id"
                               @click="onSelectEntidade(entidade)">
                    <v-list-item-content>
                      <v-list-item-title>{{ entidade.nome }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon large>mdi-chevron-right</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-skeleton-loader>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { FETCH_ENTIDADES_ACTION, SET_ENTIDADE_ACTION } from '@/store/entidade/actions.type';

export default {
  computed: {
    ...mapGetters('entidade', ['entidades', 'loading']),
  },
  methods: {
    ...mapActions('entidade', {
      setEntidade: SET_ENTIDADE_ACTION,
      fetchEntidades: FETCH_ENTIDADES_ACTION,
    }),
    getEntidades() {
      this.fetchEntidades()
        .then(() => {
          if (this.entidades.length === 1) {
            this.onSelectEntidade(this.entidades[0]);
          }
        });
    },
    onSelectEntidade(entidade) {
      this.setEntidade(entidade);
      this.$router.push({ name: 'main' });
    },
  },
  created() {
    this.getEntidades();
  },
};
</script>
